export const ApckAlertDialog = {
    props: {
        message: {
            type: String,
            default: ""
        },
        html: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        close() {
            this.$emit('close');
        }
    },
    template: `
        <div class="alert-dialog">
            <p v-if="html" v-html="message"></p>
            <p v-else>{{message}}</p>
        <hr />
            <div class="pull-right">
                <span
                    v-on:click="close"
                    class="btn-positive btn-short btn js-accept"
                >
                OK
                </span>
            </div>
        </div>
    `
}
